import { Link } from '@tanstack/react-router';
import {
  DiffedReadonlyListStack,
  type DiffedReadonlyListStackProps,
} from '@interxfi/design-system/components/list/readonly/stacked/diffed-readonly-list-stack';
import { ReadonlyListStack, type ReadonlyListStackProps } from '@interxfi/design-system/components/list/readonly/stacked/readonly-list-stack';

export function AppReadonlyListStack(props: ReadonlyListStackProps) {
  return <ReadonlyListStack defaultLinkElement={Link} {...props} />;
}

export function AppDiffedReadonlyListStack(props: DiffedReadonlyListStackProps) {
  return <DiffedReadonlyListStack defaultLinkElement={Link} {...props} />;
}
